export const ArrowDown = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '12'}
    height={height || '6'}
    viewBox={viewBox || '0 0 12 6'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path d="M12 0L6 6L0 -5.24537e-07L12 0Z" fill={fill || '#BBBEC6'} />
  </svg>
);
